import { render, staticRenderFns } from "./ScatterPlotWidget.vue?vue&type=template&id=1302a276&scoped=true"
import script from "./ScatterPlotWidget.vue?vue&type=script&lang=js"
export * from "./ScatterPlotWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1302a276",
  null
  
)

export default component.exports